import {
  DATA_COVERAGE_ALERT_WINDOW_DAYS,
  DATA_COVERAGE_CRITICAL_THRESHOLD,
  DATA_COVERAGE_THRESHOLD,
  type DataCoverageFilter,
  type DataCoverageWindowDays
} from '@willie/schemas'
import { formatPercent } from '../leak-v0/format'

export type CoverageColor = 'gray' | 'green' | 'red'

const formatThreshold = (ratio: number): string => formatPercent(ratio * 100)

const THRESHOLD = formatThreshold(DATA_COVERAGE_THRESHOLD)

export const PATCHY_DATA_LABEL = `Patchy data (< ${THRESHOLD} over ${DATA_COVERAGE_ALERT_WINDOW_DAYS} days)`

export const COVERAGE_FILTER_LABELS: Record<DataCoverageFilter, string> = {
  healthy: `Healthy (${THRESHOLD} or more)`,
  below: `Patchy (below ${THRESHOLD})`,
  critical: `Critical (below ${formatThreshold(DATA_COVERAGE_CRITICAL_THRESHOLD)})`,
  silent: `Silent (${formatThreshold(0)})`
}

export const DATA_COVERAGE_LABEL = 'Data coverage'

export const coverageColumnLabel = (days: DataCoverageWindowDays): string => `${DATA_COVERAGE_LABEL} (${days} d)`

// Floored, so a ratio just under the threshold never prints as the threshold itself.
export const formatCoverageRatio = (ratio: number | null): string =>
  ratio === null ? '—' : formatPercent(Math.floor(ratio * 1000) / 10)

export const coverageColor = (ratio: number | null): CoverageColor => {
  if (ratio === null) return 'gray'
  return ratio >= DATA_COVERAGE_THRESHOLD ? 'green' : 'red'
}
